/**
 * @generated SignedSource<<a672c5f5651a73c9b26c34c229274022>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingBasicsScreenQuery$variables = Record<PropertyKey, never>;
export type OnboardingBasicsScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingBasicsView_query">;
};
export type OnboardingBasicsScreenQuery = {
  response: OnboardingBasicsScreenQuery$data;
  variables: OnboardingBasicsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SEQUENCE_ASC"
    ]
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  (v0/*:: as any*/),
  (v1/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingBasicsScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OnboardingBasicsView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OnboardingBasicsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "beliefSystemId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "childrenPreferenceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "educationLevelId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "occupation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "politicalViewId",
                "storageKey": null
              },
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "school",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vaccinationStatusId",
                "storageKey": null
              },
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "BeliefSystemConnection",
        "kind": "LinkedField",
        "name": "beliefSystems",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeliefSystem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "beliefSystems(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "ChildrenPreferenceConnection",
        "kind": "LinkedField",
        "name": "childrenPreferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChildrenPreference",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "childrenPreferences(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "EducationLevelConnection",
        "kind": "LinkedField",
        "name": "educationLevels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EducationLevel",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "educationLevels(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "PoliticalViewConnection",
        "kind": "LinkedField",
        "name": "politicalViews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticalView",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "politicalViews(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "VaccinationStatusConnection",
        "kind": "LinkedField",
        "name": "vaccinationStatuses",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VaccinationStatus",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "vaccinationStatuses(orderBy:[\"SEQUENCE_ASC\"])"
      }
    ]
  },
  "params": {
    "cacheID": "86c758b73e34d134de6b159266aaef97",
    "id": null,
    "metadata": {},
    "name": "OnboardingBasicsScreenQuery",
    "operationKind": "query",
    "text": "query OnboardingBasicsScreenQuery {\n  ...OnboardingBasicsView_query\n}\n\nfragment BeliefSystemSelectInput_query on Query {\n  beliefSystems(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment ChildrenPreferenceSelectInput_query on Query {\n  childrenPreferences(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment EducationLevelSelectInput_query on Query {\n  educationLevels(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment OnboardingBasicsView_query on Query {\n  currentUser {\n    profile {\n      beliefSystemId\n      childrenPreferenceId\n      educationLevelId\n      occupation\n      politicalViewId\n      rowId\n      school\n      vaccinationStatusId\n      id\n    }\n    id\n  }\n  ...BeliefSystemSelectInput_query\n  ...ChildrenPreferenceSelectInput_query\n  ...EducationLevelSelectInput_query\n  ...PoliticalViewSelectInput_query\n  ...VaccinationStatusSelectInput_query\n}\n\nfragment PoliticalViewSelectInput_query on Query {\n  politicalViews(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment VaccinationStatusSelectInput_query on Query {\n  vaccinationStatuses(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1e3020c63d5b9502f0f3540275eb48a";

export default node;
